import { useState } from 'react';
import {
  AppBar, Avatar, Box, Button, styled, Toolbar, Modal, IconButton,
} from '@mui/material';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import { useSelector } from 'react-redux';
import { Link as RouterLink } from 'react-router-dom';
import { UserDetails } from '../../store/user/user-slice';
import { RootState } from '../../store';
import { stringAvatar } from '../../util/util';
import PrimaryMenu from '../menu/PrimaryMenu';
import PrimaryMenuXS from '../menu/PrimaryMenuXS';
import { LOGIN_URL } from '../../constants/ApiConstants';

const StyledToolbar = styled(Toolbar)({
  display: 'flex',
  justifyContent: 'space-between',
  paddingTop: 2,
  paddingBottom: 2,
});

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  width: { xs: '80%', sm: '60%', md: '40%' },
  height: { xs: '400px', sm: 'auto' },
  overflowY: 'auto',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  borderRadius: 2,
  boxShadow: 24,
  p: 4,
};

const UserInfo = styled(Box)(() => ({
  display: 'flex',
  gap: '20px',
  alignItems: 'center',
}));

export default function Navbar() {
  const user:UserDetails = useSelector((state: RootState) => state.user);
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <AppBar position="sticky">
      <StyledToolbar>
        <RouterLink to="/" style={{ textDecoration: 'none' }}>
          <Avatar
            alt="Logo"
            src="/assets/images/logo.png"
            sx={{ width: 60, height: 60, border: '0.1px solid white' }}
          />
        </RouterLink>
        <PrimaryMenu />
        <Box>
          <Button
            variant="contained"
            onClick={handleOpen}
            sx={{
              backgroundColor: '#6D0000',
              marginRight: { xs: 0, sm: 2 },
              color: 'white',
              '&:hover': {
                backgroundColor: '#6D0000',
                opacity: 0.8,
              },
              display: {
                xs: 'block',
                sm: 'block',
              },
            }}
          >
            Support Our Mission
          </Button>
          <Modal open={open} onClose={handleClose}>
            <Box sx={style}>
              <IconButton
                onClick={handleClose}
                sx={{
                  position: 'absolute',
                  top: 8,
                  right: 8,
                  color: 'grey.500',
                }}
              >
                <CloseIcon />
              </IconButton>
              <Typography variant="h6" component="h2" mb={2}>
                Support Our Mission
              </Typography>
              <Typography variant="body1">
                Your generous donations help us continue the mission of our Church – to serve our community, grow in faith, and reach those in need with love and compassion.
              </Typography>
              <Typography variant="body1" mt={2}>
                Whether it’s supporting parish ministries, maintaining our church facilities, or funding outreach programs, every contribution makes an impact.
              </Typography>
              <Typography variant="h6" mt={2}>
                Ways to Give:
              </Typography>
              <Typography variant="body1" mt={2}>
                In-Person during Mass
              </Typography>
              <Typography variant="body1" sx={{ fontWeight: 'bold' }} mt={2}>
                Interac to holyfamilyhalifax@gmail.com
              </Typography>
              <Typography variant="body1" mt={2} sx={{ fontWeight: 'bold' }}>
                Request a Thanksgiving or Memorial Holy Mass
              </Typography>
              <Typography variant="body1" mt={2}>
                Would you like to offer a Holy Mass in thanksgiving or in loving memory of a dear one? We invite you to submit your request by email or text.
              </Typography>
              <Typography variant="body1" mt={2}>
                Email:
                <a href="mailto: pastorholyfamilyhalifax@gmail.com">pastorholyfamilyhalifax@gmail.com</a>
              </Typography>
              <Typography variant="body1" mt={2}>
                Phone:
                <a href="tel:+13065107700">+1 306 510 7700</a>
              </Typography>
            </Box>
          </Modal>
        </Box>
        <PrimaryMenuXS />
        {user?.isLoggedIn
          && (
            <UserInfo>
              <Typography sx={{
                display: {
                  xs: 'none',
                  sm: 'block',
                },
              }}
              >
                {`${user?.userInfo.firstName} ${user?.userInfo.lastName}`}
              </Typography>
              <Avatar {...stringAvatar(`${user?.userInfo.firstName} ${user?.userInfo.lastName}`)} />
            </UserInfo>
          )}
        {!user?.isLoggedIn
          && (
            <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
              <Button
                variant="contained"
                component="a"
                href={LOGIN_URL}
                sx={{
                  backgroundColor: '#6D0000',
                  color: 'white',
                  '&:hover': {
                    backgroundColor: '#6D0000',
                    opacity: 0.8,
                  },
                  display: {
                    xs: 'none',
                    sm: 'block',
                  },
                }}
              >
                Sign In
              </Button>
            </Box>
          )}
      </StyledToolbar>
    </AppBar>
  );
}
